import React, { Component } from "react";
import { connect } from "react-redux";
import createThemedComponent from "@vitalsource/vstui/themes/createThemedComponent";
import { cloud } from "@vitalsource/vstui/colors";
import { List, Popover } from "@vitalsource/vstui/labs";
import { withTheme } from "styled-components";
import { Tools as ToolsIcon } from "../icons";
import { t } from "../../../../core/translate";
import { selectors as userSelectors } from "../../../../../redux/user";
import {
  redeemCodes,
  updateLicense,
  sharing,
  highlighters,
  facultyUpload
} from "../menu-items/tools";
import { ThemedButton } from "./styles";

const ThemedList = createThemedComponent(List, props => ({
  List_backgroundColor: props.theme.vstui.color.white,
  ListItem_color: cloud.getShade(10),
  ListItem_fontSize: "15px"
}));

class Tools extends Component {
  data() {
    return [
      {
        listItems: [redeemCodes(), updateLicense()].filter(el => !!el)
      },
      {
        listItems: [sharing(), highlighters(), facultyUpload()].filter(
          el => !!el
        )
      }
    ];
  }

  render() {
    if (this.props.loading) {
      return null;
    }

    return (
      <Popover content={<ThemedList data={this.data()} />}>
        <ThemedButton
          color="white"
          colorBehindButton={this.props.theme.vstui.color.secondary.getShade(7)}
          iconStart={<ToolsIcon />}
          label={t("global-bar.tools", "Tools")}
          tooltipPlacement="bottom"
          naked
        />
      </Popover>
    );
  }
}

const mapStateToProps = state => ({
  loading: userSelectors.isUserFetching(state)
});

export default withTheme(connect(mapStateToProps, null)(Tools));
